import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BLOG, IMAGES } from "@/data/site";
import { usePageMeta, PageHero, SectionLabel, CTABanner } from "@/components/common";

const THUMBS = [IMAGES.texture, IMAGES.repair, IMAGES.residential, IMAGES.commercial, IMAGES.restoration, IMAGES.patch, IMAGES.hero, IMAGES.interior];

export default function Blog() {
  usePageMeta("Blog & Learning Center", "Stucco tips, guides and insights from A.D.N Stucco Inc. Learn about stucco textures, repair, maintenance and how Florida weather affects your home.");
  const [feature, ...rest] = BLOG;
  return (
    <div data-testid="blog-page">
      <PageHero label="Learning Center" title="Stucco tips, guides & insights" subtitle="Everything you need to know about stucco — from finishes and maintenance to repair and Florida-specific advice." image={IMAGES.interior} />

      <section className="py-24 bg-adn-white">
        <div className="max-w-7xl mx-auto px-6">
          <Link to={`/blog/${feature.slug}`} data-testid="blog-feature" className="group grid lg:grid-cols-2 border border-zinc-200 bg-white overflow-hidden hover:shadow-xl transition-shadow duration-300">
            <div className="relative h-72 lg:h-auto overflow-hidden">
              <img src={feature.image || THUMBS[0]} alt={feature.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-10 flex flex-col justify-center">
              <span className="label-accent text-adn-red">{feature.category}</span>
              <h2 className="text-3xl font-heading font-extrabold mt-4 leading-tight">{feature.title}</h2>
              <p className="text-zinc-600 mt-4 leading-relaxed">{feature.excerpt}</p>
              <span className="text-adn-red font-semibold mt-6 flex items-center gap-2">Read article <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" /></span>
            </div>
          </Link>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
            {rest.map((b, i) => (
              <Link key={b.slug} to={`/blog/${b.slug}`} data-testid={`blog-${b.slug}`} className="group border border-zinc-200 bg-white overflow-hidden hover:-translate-y-1 hover:shadow-xl transition-all duration-300">
                <div className="relative h-44 overflow-hidden">
                  <img src={b.image || THUMBS[(i + 1) % THUMBS.length]} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <span className="absolute top-3 left-3 bg-adn-charcoal/90 text-white px-3 py-1 text-xs font-bold uppercase tracking-wider">{b.category}</span>
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-heading font-bold leading-snug">{b.title}</h3>
                  <p className="text-zinc-600 mt-2 text-sm leading-relaxed">{b.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <CTABanner />
    </div>
  );
}
